/* eslint-disable arrow-body-style */

import moment from 'moment';
import { EventTypes } from 'redux-segment';

import { GET_CATEGORIES_FAILURE, GET_CATEGORIES_REQUEST, GET_CATEGORIES_SUCCESS } from 'actions/shared.types';
import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

export const ADD_CATEGORY_REQUEST = 'ADD_CATEGORY_REQUEST';
export const ADD_CATEGORY_SUCCESS = 'ADD_CATEGORY_SUCCESS';
export const ADD_CATEGORY_FAILURE = 'ADD_CATEGORY_FAILURE';
export const EDIT_CATEGORY_REQUEST = 'EDIT_CATEGORY_REQUEST';
export const EDIT_CATEGORY_SUCCESS = 'EDIT_CATEGORY_SUCCESS';
export const EDIT_CATEGORY_FAILURE = 'EDIT_CATEGORY_FAILURE';
export const DELETE_CATEGORY_REQUEST = 'DELETE_CATEGORY_REQUEST';
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS';
export const DELETE_CATEGORY_FAILURE = 'DELETE_CATEGORY_FAILURE';
export const GET_SERVICES_REQUEST = 'GET_SERVICES_REQUEST';
export const GET_SERVICES_SUCCESS = 'GET_SERVICES_SUCCESS';
export const GET_SERVICES_FAILURE = 'GET_SERVICES_FAILURE';
export const ADD_SERVICE_REQUEST = 'ADD_SERVICE_REQUEST';
export const ADD_SERVICE_SUCCESS = 'ADD_SERVICE_SUCCESS';
export const ADD_SERVICE_FAILURE = 'ADD_SERVICE_FAILURE';
export const GET_SERVICE_REQUEST = 'GET_SERVICE_REQUEST';
export const GET_SERVICE_SUCCESS = 'GET_SERVICE_SUCCESS';
export const GET_SERVICE_FAILURE = 'GET_SERVICE_FAILURE';
export const EDIT_SERVICE_REQUEST = 'EDIT_SERVICE_REQUEST';
export const EDIT_SERVICE_SUCCESS = 'EDIT_SERVICE_SUCCESS';
export const EDIT_SERVICE_FAILURE = 'EDIT_SERVICE_FAILURE';
export const DELETE_SERVICE_REQUEST = 'DELETE_SERVICE_REQUEST';
export const DELETE_SERVICE_SUCCESS = 'DELETE_SERVICE_SUCCESS';
export const DELETE_SERVICE_FAILURE = 'DELETE_SERVICE_FAILURE';
export const POST_SERVICE_FOR_ROLE_REQUEST = 'POST_SERVICE_FOR_ROLE_REQUEST';
export const POST_SERVICE_FOR_ROLE_SUCCESS = 'POST_SERVICE_FOR_ROLE_SUCCESS';
export const POST_SERVICE_FOR_ROLE_FAILURE = 'POST_SERVICE_FOR_ROLE_FAILURE';
export const EDIT_SERVICE_FOR_ROLE_REQUEST = 'EDIT_SERVICE_FOR_ROLE_REQUEST';
export const EDIT_SERVICE_FOR_ROLE_SUCCESS = 'EDIT_SERVICE_FOR_ROLE_SUCCESS';
export const EDIT_SERVICE_FOR_ROLE_FAILURE = 'EDIT_SERVICE_FOR_ROLE_FAILURE';
export const DELETE_SERVICE_FOR_ROLE_REQUEST = 'DELETE_SERVICE_FOR_ROLE_REQUEST';
export const DELETE_SERVICE_FOR_ROLE_SUCCESS = 'DELETE_SERVICE_FOR_ROLE_SUCCESS';
export const DELETE_SERVICE_FOR_ROLE_FAILURE = 'DELETE_SERVICE_FOR_ROLE_FAILURE';
export const GET_SERVICE_TEMPLATES_REQUEST = 'GET_SERVICE_TEMPLATES_REQUEST';
export const GET_SERVICE_TEMPLATES_SUCCESS = 'GET_SERVICE_TEMPLATES_SUCCESS';
export const GET_SERVICE_TEMPLATES_FAILURE = 'GET_SERVICE_TEMPLATES_FAILURE';
export const CLEAR_SERVICES_STATE = 'CLEAR_SERVICES_STATE';
export const SET_SERVICE_SAVED = 'TOGGLE_SERVICE_SAVED';
export const REMOVE_SAVED_CATEGORIES_IDS = 'REMOVE_SAVED_CATEGORIES_IDS';
export const REMOVE_SAVED_SERVICES_IDS = 'REMOVE_SAVED_SERVICES_IDS';
export const CLEAR_REQUEST_ERROR = 'CLEAR_REQUEST_ERROR';
export const MARK_CATEGORIES_AS_FETCHED = 'MARK_CATEGORIES_AS_FETCHED';
export const CHANGE_SERVICE_POSITION = 'CHANGE_SERVICE_POSITION';
export const SAVE_SERVICE_POSITIONS_REQUEST = 'SAVE_SERVICE_POSITIONS_REQUEST';
export const SAVE_SERVICE_POSITIONS_SUCCESS = 'SAVE_SERVICE_POSITIONS_SUCCESS';
export const SAVE_SERVICE_POSITIONS_FAILURE = 'SAVE_SERVICE_POSITIONS_FAILURE';
export const CHANGE_CATEGORY_POSITION = 'CHANGE_CATEGORY_POSITION';
export const SAVE_CATEGORY_POSITIONS_REQUEST = 'SAVE_CATEGORY_POSITIONS_REQUEST';
export const SAVE_CATEGORY_POSITIONS_SUCCESS = 'SAVE_CATEGORY_POSITIONS_SUCCESS';
export const SAVE_CATEGORY_POSITIONS_FAILURE = 'SAVE_CATEGORY_POSITIONS_FAILURE';
export const GET_FUTURE_APPOINTMENTS_WITH_SERVICE_REQUEST = 'GET_FUTURE_APPOINTMENTS_WITH_SERVICE_REQUEST';
export const GET_FUTURE_APPOINTMENTS_WITH_SERVICE_SUCCESS = 'GET_FUTURE_APPOINTMENTS_WITH_SERVICE_SUCCESS';
export const GET_FUTURE_APPOINTMENTS_WITH_SERVICE_FAILURE = 'GET_FUTURE_APPOINTMENTS_WITH_SERVICE_FAILURE';
export const CLEAR_FUTURE_APPOINTMENTS_DATA = 'CLEAR_FUTURE_APPOINTMENTS_DATA';

// TODO: replace all 3 versions of this action with one new beGetServices
export function getCategories(salonId) {
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `salon/v2/${salonId}/category/services/`,
      authenticated: true,
      types: [GET_CATEGORIES_REQUEST, GET_CATEGORIES_SUCCESS, GET_CATEGORIES_FAILURE],
    },
  };
}

export const addCategory = (name, color, salonId) => {
  const category = {
    name,
    color,
  };
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(category),
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/category/salon/${salonId}/`,
      authenticated: true,
      types: [ADD_CATEGORY_REQUEST, ADD_CATEGORY_SUCCESS, ADD_CATEGORY_FAILURE],
      config,
    },
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'addCategory',
          properties: {
            name,
          },
        },
      },
    },
  };
};
export const editCategory = (category, salonId) => {
  const config = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(category),
  };
  if (!category.id) {
    return EDIT_CATEGORY_FAILURE;
  }
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/category/${category.id}/`,
      authenticated: true,
      types: [EDIT_CATEGORY_REQUEST, EDIT_CATEGORY_SUCCESS, EDIT_CATEGORY_FAILURE],
      config,
      params: { categoryId: category.id },
    },
  };
};
export const deleteCategory = (categoryId, salonId) => {
  const config = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/category/${categoryId}/`,
      authenticated: true,
      types: [DELETE_CATEGORY_REQUEST, DELETE_CATEGORY_SUCCESS, DELETE_CATEGORY_FAILURE],
      config,
      params: {
        categoryId,
      },
    },
  };
};
export const addInitialCategories = (salonId) => {
  return (dispatch) =>
    dispatch(addCategory('Colour', '#c93b7e', salonId)).then(
      () =>
        // eslint-disable-next-line promise/no-nesting
        void dispatch(addCategory('Cutting', '#3da49d', salonId)).then(
          () =>
            // eslint-disable-next-line promise/no-nesting
            void dispatch(addCategory('Styling', '#7300af', salonId)).then(
              // eslint-disable-next-line promise/no-nesting
              () => void dispatch(addCategory('Treatments', '#5e72d1', salonId)).then(alwaysNoop),
            ),
        ),
    );
};

export function getServices(salonId, categoryId) {
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/service/category/${categoryId}/`,
      authenticated: true,
      types: [GET_SERVICES_REQUEST, GET_SERVICES_SUCCESS, GET_SERVICES_FAILURE],
      params: {
        categoryId,
      },
    },
  };
}

export const postService = (service, salonId, categoryId) => {
  const serviceToAdd = {
    name: service.name,
    duration: moment(service.duration, 'HH:mm').format('HH:mm:ss'),
    processing: moment(service.processing, 'HH:mm').format('HH:mm:ss'),
    variable_pricing: service.variable_pricing,
    price: parseFloat(service.price),
  };
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(serviceToAdd),
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/service/category/${categoryId}/`,
      authenticated: true,
      types: [ADD_SERVICE_REQUEST, ADD_SERVICE_SUCCESS, ADD_SERVICE_FAILURE],
      config,
      params: {
        categoryId,
      },
    },
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'postService',
          properties: {
            name: service.name,
          },
        },
      },
    },
  };
};

export function getService(serviceId, salonId) {
  const config = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/service/${serviceId}/`,
      authenticated: true,
      types: [GET_SERVICE_REQUEST, GET_SERVICE_SUCCESS, GET_SERVICE_FAILURE],
      config,
    },
  };
}

export function putService(service, salonId) {
  const serviceToEdit = Object.assign({}, service);
  serviceToEdit.duration = moment(service.duration, 'HH:mm').format('HH:mm:ss');
  serviceToEdit.processing = moment(service.processing, 'HH:mm').format('HH:mm:ss');
  // serviceToEdit.role_executions = undefined;
  const config = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(serviceToEdit),
  };
  if (!service.id) {
    return { type: EDIT_SERVICE_FAILURE };
  }
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/service/${service.id}/`,
      authenticated: true,
      types: [EDIT_SERVICE_REQUEST, EDIT_SERVICE_SUCCESS, EDIT_SERVICE_FAILURE],
      config,
      params: { serviceId: service.id },
    },
  };
}

export function deleteService(salonId, serviceId) {
  const config = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/service/${serviceId}/`,
      authenticated: true,
      types: [DELETE_SERVICE_REQUEST, DELETE_SERVICE_SUCCESS, DELETE_SERVICE_FAILURE],
      config,
      params: {
        serviceId,
      },
    },
  };
}

export function setServiceSaved(value) {
  return {
    type: SET_SERVICE_SAVED,
    value,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function postServiceDetailsForRole(serviceDetails, serviceId, salonId) {
  const data = {
    service: serviceId,
    price: serviceDetails.price || 0,
    duration: serviceDetails.duration,
    processing: serviceDetails.processing,
  };
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/role/services/${serviceDetails.role_id}/`,
      authenticated: true,
      types: [POST_SERVICE_FOR_ROLE_REQUEST, POST_SERVICE_FOR_ROLE_SUCCESS, POST_SERVICE_FOR_ROLE_FAILURE],
      config,
    },
  };
}

export function putServiceDetailsForRole(serviceDetails, serviceId, salonId, updateFlags) {
  const data = {
    ...updateFlags,
    service: serviceId,
    price: serviceDetails.price,
    duration: serviceDetails.duration,
    processing: serviceDetails.processing,
  };
  const config = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/role/services/${serviceDetails.role_id}/`,
      authenticated: true,
      types: [EDIT_SERVICE_FOR_ROLE_REQUEST, EDIT_SERVICE_FOR_ROLE_SUCCESS, EDIT_SERVICE_FOR_ROLE_FAILURE],
      config,
    },
  };
}

export function deleteServiceDetailsForRole(roleId, serviceId, salonId) {
  const config = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      service: serviceId,
    }),
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/role/services/${roleId}/`,
      authenticated: true,
      types: [DELETE_SERVICE_FOR_ROLE_REQUEST, DELETE_SERVICE_FOR_ROLE_SUCCESS, DELETE_SERVICE_FOR_ROLE_FAILURE],
      config,
    },
  };
}

function postAllServiceDetailsForRole(allServicesDetails, serviceId, salonId) {
  return (dispatch) => {
    const services = allServicesDetails.filter((svrs) => svrs.role_id !== -1);

    const promises = [];
    services.forEach((srvs) => {
      promises.push(dispatch(postServiceDetailsForRole(srvs, serviceId, salonId)));
    });

    return Promise.all(promises);
  };
}

function deleteAllServiceDetailsForRole(allServicesDetails, serviceId, salonId) {
  return (dispatch) => {
    const services = allServicesDetails.filter((svrs) => svrs.role_id !== -1);

    const promises = [];
    services.forEach((srvs) => {
      promises.push(dispatch(deleteServiceDetailsForRole(srvs.role_id, serviceId, salonId)));
    });

    return Promise.all(promises);
  };
}

function editAllServiceDetailsForRole(allServicesDetails, serviceId, salonId, updateFlags) {
  return (dispatch) => {
    const services = allServicesDetails.filter((svrs) => svrs.role_id !== -1);

    const promises = [];
    services.forEach((srvs) => {
      promises.push(dispatch(putServiceDetailsForRole(srvs, serviceId, salonId, updateFlags)));
    });

    return Promise.all(promises);
  };
}

export function addService(service, categoryId, salonId) {
  return (dispatch) => {
    dispatch(postService(service, salonId, categoryId)).then(({ response, type }) => {
      if (type === ADD_SERVICE_SUCCESS && response.id) {
        dispatch(postAllServiceDetailsForRole(service.role_executions, response.id, salonId)).then(() => {
          if (response.id) {
            // eslint-disable-next-line promise/no-nesting
            dispatch(getService(response.id, salonId)).then(() => void dispatch(setServiceSaved(true)));
            dispatch(getCategories(salonId));
          }
        });
      }
    });
  };
}

export function editService(
  service,
  salonId,
  updateFlags = {
    update_related_custom_priced_procedures: false,
    update_related_default_priced_procedures: false,
    update_procedures_older_than: moment().startOf('day').toISOString(),
  },
) {
  const serviceToSend = Object.assign(service);
  let serviceId = 0;
  return (dispatch) => {
    if (!serviceToSend.id) {
      return;
    }
    serviceId = serviceToSend.id;
    dispatch(getService(serviceId, salonId)).then(({ response, type }) => {
      if (type !== GET_SERVICE_SUCCESS) return;

      const toPut = [];
      for (let i = 0; i < serviceToSend.role_executions.length; i += 1) {
        for (let j = 0; j < response.role_executions.length; j += 1) {
          if (serviceToSend.role_executions[i].role_id === response.role_executions[j].role_id) {
            if (JSON.stringify(serviceToSend.role_executions[i]) !== JSON.stringify(response.role_executions[j])) {
              toPut.push(Object.assign({}, serviceToSend.role_executions[i]));
            }
            serviceToSend.role_executions[i].role_id = -1;
            response.role_executions[j].role_id = -1;
            break;
          }
        }
      }

      dispatch(postAllServiceDetailsForRole(serviceToSend.role_executions, serviceId, salonId))
        .then(
          () =>
            // eslint-disable-next-line promise/no-nesting
            void dispatch(deleteAllServiceDetailsForRole(response.role_executions, serviceId, salonId)).then(
              () =>
                // eslint-disable-next-line promise/no-nesting
                void dispatch(editAllServiceDetailsForRole(toPut, serviceId, salonId, updateFlags)).then(
                  () =>
                    // eslint-disable-next-line promise/no-nesting
                    void dispatch(putService(serviceToSend, salonId)).then(
                      () =>
                        // eslint-disable-next-line promise/no-nesting
                        void dispatch(getService(serviceId, salonId)).then(() => void dispatch(setServiceSaved(true))),
                    ),
                ),
            ),
        )
        // eslint-disable-next-line promise/no-nesting
        .catch(() => ({ type: EDIT_SERVICE_FAILURE }));
    });
  };
}

export function getServiceTemplates() {
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: 'services/v1/templates/',
      authenticated: true,
      types: [GET_SERVICE_TEMPLATES_REQUEST, GET_SERVICE_TEMPLATES_SUCCESS, GET_SERVICE_TEMPLATES_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  };
}

export function clearServicesState() {
  return {
    type: CLEAR_SERVICES_STATE,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function removeSavedCategoriesIds(idsToRemove) {
  return {
    type: REMOVE_SAVED_CATEGORIES_IDS,
    idsToRemove,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function removeSavedServicesIds(idsToRemove) {
  return {
    type: REMOVE_SAVED_SERVICES_IDS,
    idsToRemove,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function clearRequestError() {
  return {
    type: CLEAR_REQUEST_ERROR,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function markCategoriesAsFetched() {
  return {
    type: MARK_CATEGORIES_AS_FETCHED,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function changeServicePosition(serviceToInsert, serviceAt) {
  return {
    type: CHANGE_SERVICE_POSITION,
    serviceToInsert,
    serviceAt,
  };
}

export function saveServicesPositions(salonId, categoryId, ids) {
  const config = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(ids),
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/service/${categoryId}/sort/`,
      authenticated: true,
      types: [SAVE_SERVICE_POSITIONS_REQUEST, SAVE_SERVICE_POSITIONS_SUCCESS, SAVE_SERVICE_POSITIONS_FAILURE],
      config,
    },
  };
}

export function changeCategoryPosition(categoryToInsert, categoryAt) {
  return (dispatch, getState) => {
    dispatch({
      type: CHANGE_CATEGORY_POSITION,
      categoryToInsert,
      categoryAt,
    }).then(() => {
      const config = {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(getState().onboarding.services.categories.map((cat) => cat.id || 0)),
      };
      dispatch({
        [AUTH_API]: {
          api_root: CONF.apiRoot,
          endpoint: `services/v1/salon/${getState().currentSalon.id}/category/sort/`,
          authenticated: true,
          types: [SAVE_CATEGORY_POSITIONS_REQUEST, SAVE_CATEGORY_POSITIONS_SUCCESS, SAVE_CATEGORY_POSITIONS_FAILURE],
          config,
        },
      });
    });
  };
}

export function saveCategoryPositions(salonId, categoryIds) {
  const config = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(categoryIds),
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/category/sort/`,
      authenticated: true,
      types: [SAVE_CATEGORY_POSITIONS_REQUEST, SAVE_CATEGORY_POSITIONS_SUCCESS, SAVE_CATEGORY_POSITIONS_FAILURE],
      config,
    },
  };
}

export function getFutureAppointmentsWithService(salonId, serviceId, differentPricesRolesIds, checkFromDate) {
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      // eslint-disable-next-line max-len
      endpoint: `services/v1/salon/${salonId}/role/services/procedures/?start_time=${checkFromDate}&execution_ids=${differentPricesRolesIds.join(
        ',',
      )}`,
      authenticated: true,
      types: [
        GET_FUTURE_APPOINTMENTS_WITH_SERVICE_REQUEST,
        GET_FUTURE_APPOINTMENTS_WITH_SERVICE_SUCCESS,
        GET_FUTURE_APPOINTMENTS_WITH_SERVICE_FAILURE,
      ],
    },
  };
}

export function clearFutureAppointmentsData() {
  return {
    type: CLEAR_FUTURE_APPOINTMENTS_DATA,
  };
}
